var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.9793 5.52633C33.1367 3.1585 36.8628 3.1585 39.0202 5.52633C40.846 7.53029 43.6716 8.28743 46.2548 7.46485C49.307 6.49291 52.534 8.356 53.2184 11.4853C53.7976 14.1336 55.8661 16.2022 58.5145 16.7814C61.6438 17.4658 63.5069 20.6927 62.5349 23.7449C61.7123 26.3281 62.4695 29.1538 64.4734 30.9796C66.8413 33.1369 66.8413 36.8631 64.4734 39.0204C62.4695 40.8462 61.7123 43.6719 62.5349 46.2551C63.5069 49.3073 61.6438 52.5342 58.5145 53.2186C55.8661 53.7978 53.7976 55.8664 53.2184 58.5147C52.534 61.644 49.307 63.5071 46.2548 62.5352C43.6716 61.7126 40.846 62.4697 39.0202 64.4737C36.8628 66.8415 33.1367 66.8415 30.9793 64.4737C29.1535 62.4697 26.3279 61.7126 23.7447 62.5352C20.6925 63.5071 17.4655 61.644 16.7811 58.5147C16.2019 55.8664 14.1334 53.7978 11.485 53.2186C8.35575 52.5342 6.49266 49.3073 7.4646 46.2551C8.28718 43.6719 7.53005 40.8462 5.52609 39.0204C3.15825 36.8631 3.15825 33.1369 5.52609 30.9796C7.53005 29.1538 8.28718 26.3281 7.4646 23.7449C6.49266 20.6927 8.35575 17.4658 11.485 16.7814C14.1334 16.2022 16.2019 14.1336 16.7811 11.4853C17.4655 8.356 20.6925 6.49291 23.7447 7.46485C26.3279 8.28743 29.1535 7.53029 30.9793 5.52633Z",
    fill: "white",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    id: "path1",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.031 35.8857V22.9688H34.1979L19.6873 37.4794L32.6042 50.3964L47.031 35.8857ZM41.8307 30.3499C38.9789 30.0144 38.9789 26.3238 41.8307 25.9044C44.6825 26.3238 44.6825 30.0144 41.8307 30.3499Z",
    fill: "#845EC2",
    id: "path2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSell);
export default __webpack_public_path__ + "static/media/sell.e083c1c0a189a5e7ba1c827a6994cf4e.svg";
export { ForwardRef as ReactComponent };